import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_ussd_settings: { message: "idle" },
};

export const retrieve_ussd_settings_Slice = createSlice({
 name: "retrieve_ussd_settings",
 initialState,
 reducers: {
  success_retrieve_ussd_settings: (state, action) => {
   state.retrieve_ussd_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_ussd_settings: (state, action) => {
   state.retrieve_ussd_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_ussd_settings: (state) => {
   state.retrieve_ussd_settings = { status: app_consts.IDLE };
  },
  loading_retrieve_ussd_settings: (state) => {
   state.retrieve_ussd_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_ussd_settings, fail_retrieve_ussd_settings, reset_retrieve_ussd_settings, loading_retrieve_ussd_settings } = retrieve_ussd_settings_Slice.actions;

export default retrieve_ussd_settings_Slice.reducer;